import getGenericTableComponent from 'src/platform/components/componentGetters/getGenericTableComponent';
import setCurrentMode from './setCurrentMode';
export default function setCurrentModeAsGenericTable(props) {
    setCurrentMode({
        component: getGenericTableComponent(),
        componentProps: props
    });
}
